export const EDENRED_ACOUNT_URL = `user-access/edenred/account`;

export const REVALIDATE_ONLY_ON_MOUNT_SWR_OPTIONS = {
  revalidateOnFocus: false,
  revalidateOnMount: true,
  revalidateOnReconnect: false,
  revalidateIfStale: false,
  refreshWhenOffline: false,
  refreshWhenHidden: false,
  refreshInterval: 0,
};
